<template>
    <div
        class="ds-smile-static"
        :class="{
            'ds-smile-static--with-shadow': withShadow,
            'ds-smile-static--responsive': responsive,
            'ds-smile-static--contain': size === 'contain',
        }"
    >
        <div class="ds-smile-static__inner">
            <div class="ds-smile-static__body">
                <img
                    :src="resolvedBody"
                    alt="Kulicnik bg"
                    class="ds-smile-static__bg"
                    :width="width"
                    :height="height"
                />
                <img
                    :src="resolvedFace"
                    alt="Kulicnik bg"
                    class="ds-smile-static__face"
                    :width="width"
                    :height="height"
                />
            </div>
            <div
                v-if="withShadow"
                class="ds-smile-static__shadow"
                :class="[shadowColor !== 'orange' && `ds-smile-static__shadow--${shadowColor}`]"
            />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { DsSmileStaticFacePosition, DsSmileStaticFaceType } from "./ds-smile-static-types";

const props = withDefaults(
    defineProps<{
        /**
         * Set face type
         */
        faceType?: DsSmileStaticFaceType;
        /**
         * Set face position
         */
        facePosition?: DsSmileStaticFacePosition;
        /**
         * Enable shadow under image
         */
        withShadow?: boolean;
        /**
         * Enable responsive mode
         */
        responsive?: boolean;
        /**
         * Set containment of image
         */
        size?: "default" | "contain";
        /**
         * Set shadow color
         */
        shadowColor?: "orange" | "gray" | "black";
        /**
         * Set width
         */
        width?: number;
        /**
         * Set height
         */
        height?: number;
        /**
         * Set SB path
         */
        isInStorybook?: boolean;
    }>(),
    {
        faceType: DsSmileStaticFaceType.DefaultSmile,
        facePosition: DsSmileStaticFacePosition.Center,
        withShadow: true,
        responsive: true,
        size: "default",
        shadowColor: "orange",
        isInStorybook: false,
    }
);

const resolvedBody = computed(() => {
    if (props.isInStorybook) return "/images/img/design-system/smiles/smile-static/body.svg";

    return "/frontend/web/img/design-system/smiles/smile-static/body.svg";
});

const resolvedFace = computed(() => {
    if (props.isInStorybook)
        return `/images/img/design-system/smiles/smile-static/face/${props.faceType}--${props.facePosition}.svg`;

    return `/frontend/web/img/design-system/smiles/smile-static/faces/${props.faceType}--${props.facePosition}.svg`;
});
</script>
